// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"296":"monaco-31aa33e4","335":"monaco-c4070907","617":"monaco-b7831af0","902":"monaco-8cae5cd0"}[chunkId] + "." + {"296":"0ca0af9ccd33100d","335":"c224d298c47fb642","617":"b21a7837275d5876","902":"66517fe03851c835"}[chunkId] + ".js";
};